"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Util_1 = require("../Util");
/**
 * Handles values that are part of an array.
 */


var EntryHandlerArrayValue =
/*#__PURE__*/
function () {
  function EntryHandlerArrayValue() {
    _classCallCheck(this, EntryHandlerArrayValue);
  }

  _createClass(EntryHandlerArrayValue, [{
    key: "isPropertyHandler",
    value: function isPropertyHandler() {
      return false;
    }
  }, {
    key: "validate",
    value: function () {
      var _validate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(parsingContext, util, keys, depth, inProperty) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.test(parsingContext, util, null, keys, depth));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function validate(_x, _x2, _x3, _x4, _x5) {
        return _validate.apply(this, arguments);
      }

      return validate;
    }()
  }, {
    key: "test",
    value: function () {
      var _test = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(parsingContext, util, key, keys, depth) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", typeof keys[depth] === 'number');

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function test(_x6, _x7, _x8, _x9, _x10) {
        return _test.apply(this, arguments);
      }

      return test;
    }()
  }, {
    key: "handle",
    value: function () {
      var _handle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(parsingContext, util, key, keys, value, depth) {
        var parentKey, listRootKey, listRootDepth, i, keyOption, object, parentContext, _object;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return util.unaliasKeywordParent(keys, depth);

              case 2:
                parentKey = _context3.sent;

                if (!(parentKey === '@list')) {
                  _context3.next = 45;
                  break;
                }

                // Our value is part of an array
                // Determine the list root key
                listRootKey = null;
                i = depth - 2;

              case 6:
                if (!(i > 0)) {
                  _context3.next = 15;
                  break;
                }

                keyOption = keys[i];

                if (!(typeof keyOption === 'string')) {
                  _context3.next = 12;
                  break;
                }

                listRootDepth = i;
                listRootKey = keyOption;
                return _context3.abrupt("break", 15);

              case 12:
                i--;
                _context3.next = 6;
                break;

              case 15:
                _context3.t0 = listRootKey === '@list';

                if (_context3.t0) {
                  _context3.next = 27;
                  break;
                }

                _context3.t1 = listRootDepth !== depth - 2 && typeof keys[depth - 2] === 'number';

                if (!_context3.t1) {
                  _context3.next = 26;
                  break;
                }

                _context3.t2 = Util_1.Util;
                _context3.next = 22;
                return parsingContext.getContext(keys, listRootDepth - depth);

              case 22:
                _context3.t3 = _context3.sent;
                _context3.t4 = listRootKey;
                _context3.t5 = _context3.t2.getContextValueContainer.call(_context3.t2, _context3.t3, _context3.t4);
                _context3.t1 = _context3.t5 === '@list';

              case 26:
                _context3.t0 = _context3.t1;

              case 27:
                if (!_context3.t0) {
                  _context3.next = 29;
                  break;
                }

                throw new Error("Lists of lists are not supported: '".concat(listRootKey, "'"));

              case 29:
                _context3.t6 = util;
                _context3.next = 32;
                return parsingContext.getContext(keys);

              case 32:
                _context3.t7 = _context3.sent;
                _context3.t8 = listRootKey;
                _context3.t9 = value;
                _context3.t10 = depth;
                _context3.t11 = keys;
                _context3.next = 39;
                return _context3.t6.valueToTerm.call(_context3.t6, _context3.t7, _context3.t8, _context3.t9, _context3.t10, _context3.t11);

              case 39:
                object = _context3.sent;

                if (!(listRootKey !== null)) {
                  _context3.next = 43;
                  break;
                }

                _context3.next = 43;
                return this.handleListElement(parsingContext, util, object, depth, keys.slice(0, listRootDepth), listRootDepth, listRootKey, keys);

              case 43:
                _context3.next = 73;
                break;

              case 45:
                if (!(parentKey === '@set')) {
                  _context3.next = 50;
                  break;
                }

                _context3.next = 48;
                return parsingContext.newOnValueJob(keys.slice(0, -2), value, depth - 2);

              case 48:
                _context3.next = 73;
                break;

              case 50:
                if (!(parentKey !== undefined && parentKey !== '@type')) {
                  _context3.next = 73;
                  break;
                }

                _context3.next = 53;
                return parsingContext.getContext(keys.slice(0, -1));

              case 53:
                parentContext = _context3.sent;

                if (!(Util_1.Util.getContextValueContainer(parentContext, parentKey) === '@list')) {
                  _context3.next = 70;
                  break;
                }

                _context3.t12 = util;
                _context3.next = 58;
                return parsingContext.getContext(keys);

              case 58:
                _context3.t13 = _context3.sent;
                _context3.t14 = parentKey;
                _context3.t15 = value;
                _context3.t16 = depth;
                _context3.t17 = keys;
                _context3.next = 65;
                return _context3.t12.valueToTerm.call(_context3.t12, _context3.t13, _context3.t14, _context3.t15, _context3.t16, _context3.t17);

              case 65:
                _object = _context3.sent;
                _context3.next = 68;
                return this.handleListElement(parsingContext, util, _object, depth, keys.slice(0, -1), depth - 1, parentKey, keys);

              case 68:
                _context3.next = 73;
                break;

              case 70:
                // Copy the id stack value up one level so that the next job can access the id.
                if (parsingContext.idStack[depth + 1]) {
                  parsingContext.idStack[depth] = parsingContext.idStack[depth + 1];
                  parsingContext.emittedStack[depth] = true;
                } // Execute the job one level higher


                _context3.next = 73;
                return parsingContext.newOnValueJob(keys.slice(0, -1), value, depth - 1);

              case 73:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handle(_x11, _x12, _x13, _x14, _x15, _x16) {
        return _handle.apply(this, arguments);
      }

      return handle;
    }()
  }, {
    key: "handleListElement",
    value: function () {
      var _handleListElement = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(parsingContext, util, value, depth, listRootKeys, listRootDepth, listRootKey, keys) {
        var listPointer, linkTerm, listRootContext, predicate, reverse, newLinkTerm, _predicate;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // Buffer our value as an RDF list using the listRootKey as predicate
                listPointer = parsingContext.listPointerStack[depth];

                if (!value) {
                  _context4.next = 23;
                  break;
                }

                if (!(!listPointer || !listPointer.term)) {
                  _context4.next = 17;
                  break;
                }

                linkTerm = util.dataFactory.blankNode();
                _context4.next = 6;
                return parsingContext.getContext(listRootKeys);

              case 6:
                listRootContext = _context4.sent;
                _context4.next = 9;
                return util.predicateToTerm(listRootContext, listRootKey);

              case 9:
                predicate = _context4.sent;
                reverse = Util_1.Util.isPropertyReverse(listRootContext, listRootKey, keys[listRootDepth - 1]); // Lists are not allowed in @reverse'd properties

                if (!(reverse && !parsingContext.allowSubjectList)) {
                  _context4.next = 13;
                  break;
                }

                throw new Error("Found illegal list value in subject position at ".concat(listRootKey));

              case 13:
                parsingContext.getUnidentifiedValueBufferSafe(listRootDepth).push({
                  predicate: predicate,
                  object: linkTerm,
                  reverse: reverse
                });
                listPointer = {
                  term: linkTerm,
                  initialPredicate: null,
                  listRootDepth: listRootDepth
                };
                _context4.next = 20;
                break;

              case 17:
                // rdf:rest links are always emitted before the next element,
                // as the blank node identifier is only created at that point.
                // Because of this reason, the final rdf:nil is emitted when the stack depth is decreased.
                newLinkTerm = util.dataFactory.blankNode();
                parsingContext.emitQuad(depth, util.dataFactory.quad(listPointer.term, util.rdfRest, newLinkTerm, util.getDefaultGraph())); // Update the list pointer for the next element

                listPointer.term = newLinkTerm;

              case 20:
                // Emit a list element for the current value
                parsingContext.emitQuad(depth, util.dataFactory.quad(listPointer.term, util.rdfFirst, value, util.getDefaultGraph()));
                _context4.next = 33;
                break;

              case 23:
                if (listPointer) {
                  _context4.next = 33;
                  break;
                }

                _context4.t0 = util;
                _context4.next = 27;
                return parsingContext.getContext(listRootKeys);

              case 27:
                _context4.t1 = _context4.sent;
                _context4.t2 = listRootKey;
                _context4.next = 31;
                return _context4.t0.predicateToTerm.call(_context4.t0, _context4.t1, _context4.t2);

              case 31:
                _predicate = _context4.sent;
                listPointer = {
                  term: null,
                  initialPredicate: _predicate,
                  listRootDepth: listRootDepth
                };

              case 33:
                parsingContext.listPointerStack[depth] = listPointer;

              case 34:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function handleListElement(_x17, _x18, _x19, _x20, _x21, _x22, _x23, _x24) {
        return _handleListElement.apply(this, arguments);
      }

      return handleListElement;
    }()
  }]);

  return EntryHandlerArrayValue;
}();

exports.EntryHandlerArrayValue = EntryHandlerArrayValue;